import React, { useState, useEffect } from 'react';
import { getPdfs } from '../api/pdfApi';
import Footer from './Footer';

function Opportunities() {
  const [pdfs, setPdfs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchPdfs = async () => {
      try {
        const pdfData = await getPdfs("Opportunities");
        console.log("📄 Debug PDFs:", pdfData);
        setPdfs(pdfData.sort((a, b) => new Date(b.date) - new Date(a.date)));
      } catch (err) {
        console.error("❌ Error fetching PDFs", err);
        setError("Failed to load opportunities.");
      } finally {
        setLoading(false);
      }
    };
    fetchPdfs();
  }, []);

  if (loading) return <p className="text-center text-gray-600">Loading opportunities...</p>;
  if (error) return <p className="text-center text-red-500">{error}</p>;


  return (

    <div>
      {/* Full-width Image Header */}
      <div className="relative w-full m-h-screen mt-0">
        <img
          src="/Hero-Opportunities.jpeg"
          // className="w-full h-[70vh] object-cover"
          // className="w-full object-cover object-center h-[45vh] sm:h-[55vh] md:h-[65vh] lg:h-[75vh] xl:h-[85vh]"
          className="w-full h-auto object-cover object-center"
        />
        <div className="absolute inset-x-0 bottom-0 sm:bottom-4 left-0 right-0 text-white text-center px-6 sm:px-12">
          <div className="bg-black bg-opacity-50 p-2 sm:p-6 rounded-lg inline-block">
            <h1 className="text-xl sm:text-5xl font-bold drop-shadow-lg">Joining The Lab</h1>
          </div>
        </div>
      </div>



      <div className="max-w-4xl mx-auto px-6 py-12">
        {/* Page Title */}
        {/* <div className="text-center mb-12">
        <h1 className="text-5xl font-bold text-primary">Joining the Lab</h1>
      </div> */}

        {/* Post Doctoral Opportunity */}
        <SectionCard title="Current Opportunities Available">
          <p className="text-lg text-gray-700 mb-4">
            Please follow the links to view our current available opportunities.
          </p>

          {/*List of Opportunities PDFs */}
          {pdfs.length > 0 ? (
            <ul className="list-disc pl-5 space-y-2">
              {pdfs.map((pdf) => (
                <li key={pdf._id}>
                  <a
                    href={pdf.pdfUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-secondary hover:underline"
                  >
                    {pdf.title || "View PDF"}
                  </a>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-gray-500 italic">No opportunities available.</p>
          )}
        </SectionCard>

        {/* Graduate Student Opportunities */}
        <SectionCard title="Graduate Student Opportunities">
          <p className="text-lg text-gray-700 mb-4">
            Dr. Owen accepts students from four of Western's premier graduate programs: Psychology, Neuroscience, Philosophy, and Physiology & Pharmacology.
          </p>
          <p className="text-lg text-gray-700">
            Please do not send applications directly to the Owen Lab. Each of these programs has their own admission requirements that can be found on the relevant Western University websites. Please submit your application to those programs directly and they will reach us at Owen Lab.
          </p>
        </SectionCard>

        {/* Volunteer Positions */}
        <SectionCard title="Volunteer Positions">
          <p className="text-lg text-gray-700">
            If you are interested in a volunteer position, please send your CV,
            a copy of your transcript, and a sample of your writing to
            <a href="mailto:OwenLab@uwo.ca" className="text-secondary hover:underline ml-1">OwenLab@uwo.ca</a>.
          </p>
        </SectionCard>
      </div>
      <Footer isFullFooter={false} />
    </div>
  );
}

/* Section Wrapper */
const SectionCard = ({ title, children }) => (
  <section className="bg-white border border-gray-200 shadow-lg rounded-xl p-6 mb-8">
    <h2 className="text-2xl font-semibold text-primary mb-4">{title}</h2>
    {children}
  </section>
);

export default Opportunities;


